import { MenuItem, TextField } from "@mui/material";
import { Environment } from "../../../backend/interactiveTypes";
import { useState, useEffect } from "react";

interface EnvironmentSelectProps {
  executionFileSource: string;
  setExecutionFileSource: (value: string) => void;
  environments: Environment[];
  isLoading: boolean;
}
export function EnvironmentSelect(props: EnvironmentSelectProps) {
  return (
    <>
      <TextField
        select
        id="job-environment-option"
        value={props.executionFileSource}
        label="Environment"
        disabled={props.isLoading}
        onChange={(event) =>
          props.setExecutionFileSource(event.target.value as string)
        }
      >
        <MenuItem value="phil">PHIL File System</MenuItem>
        {props.environments?.map((environment: Environment) => (
          <MenuItem
            key={environment.environmentId}
            value={environment.environmentId}
          >
            {environment.environmentName}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}
